/**
 * UI fallback when camera permission is denied or blocked
 * Used for future radiation proxy (vision-camera) in V1.1
 */

import React from 'react';
import { View, Text, Pressable, StyleSheet } from 'react-native';
import { useCameraPermission } from '../hooks';

const ACCENT_CYAN = '#00d4ff';

export function CameraPermissionFallback() {
  const {
    status,
    isGranted,
    isBlocked,
    requestPermission,
    openAppSettings,
  } = useCameraPermission();

  if (status === 'checking' || isGranted || status === 'unavailable') {
    return null;
  }

  return (
    <View style={styles.container}>
      <Text style={styles.message}>
        {isBlocked
          ? 'Camera access was denied. Enable it in Settings for future radiation proxy detection.'
          : 'Camera permission is needed for future radiation proxy detection.'}
      </Text>
      <Pressable
        style={({ pressed }) => [styles.button, pressed && styles.buttonPressed]}
        onPress={isBlocked ? openAppSettings : requestPermission}
      >
        <Text style={styles.buttonText}>
          {isBlocked ? 'Open Settings' : 'Allow Camera'}
        </Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 16,
    backgroundColor: '#12182a',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#1e2a42',
    marginBottom: 16,
  },
  message: {
    color: '#8892a6',
    fontSize: 14,
    marginBottom: 12,
  },
  button: {
    backgroundColor: ACCENT_CYAN,
    padding: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  buttonPressed: { opacity: 0.8 },
  buttonText: {
    color: '#0a0e17',
    fontWeight: '600',
  },
});
